// components/MenuItem.jsx

import React from "react";
import { motion } from "framer-motion";

const variants = {
  open: {
    y: 0,
    opacity: 1,
    transition: {
      y: { stiffness: 1000, velocity: -100 },
    },
  },
  closed: {
    y: 50,
    opacity: 0,
    transition: {
      y: { stiffness: 1000 },
    },
  },
};

const handleScroll = (id) => {
  const el = document.getElementById(id);
  if (el) {
    el.scrollIntoView({ behavior: "smooth" });
  }
}

export const MenuItem = ({ items }) => {
  return (
    <>
      {items.map((item, index) => (
        <motion.li
          key={index}
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
          className="motion-li"
          variants={variants}
          onClick={() => handleScroll(item.targetId)}
        >
          <a href={`#${item.targetId}`}>
            {item.name}
          </a>
        </motion.li>
      ))}
    </>
  );
};
